// work data

export const Work = [
    {
        id:1,
        level:"01",
        name:"KuriLabo",
        shortName:"KL",
        status:"IN PROGRESS",
        role:"MOBILE + FULL STACK",
        accent:"#4FC9FF",
        description:"Building an iOS-first booking and CRM platform for nail salons using React Native, TypeScript, and Supabase — with authentication, scheduling, client photo browsing, and admin management capabilities.",
        tags:["React Native","TypeScript","Supabase"],

        demo:"https://github.com/hermiaTT/KuriLaboNailCRM",
        github:"https://github.com/hermiaTT/KuriLaboNailCRM"
    },
    {
        id:2,
        level:"02",
        name:"MarketPlace Helper",
        shortName:"MP",
        status:"BUILT",
        role:"AUTOMATION",
        accent:"#8CE04A",
        description:"A web app that watches my Facebook Marketplace selling listings and flags it whenever a listing's price changes.",
        tags:["JavaScript","Automation","Web Scraping"],

        demo:"https://github.com/hermiaTT/MarketPlaceHelper",
        download:"https://github.com/hermiaTT/openroadAssistant/releases/latest/download/OpenRoad-Assistant-Windows.zip",
        github:"https://github.com/hermiaTT/MarketPlaceHelper"
    },
    {
        id:3,
        level:"03",
        name:"WanderingFoodCart",
        shortName:"WFC",
        status:"IN PROGRESS",
        role:"GAME DEVELOPMENT",
        accent:"#FFD93D",
        description:"Developing a Unity-based game with custom shader-driven visual effects (ShaderLab/HLSL), using GitHub Copilot to accelerate gameplay scripting.",
        tags:["Unity","ShaderLab/HLSL","GitHub Copilot"],

        demo:"https://github.com/hermiaTT/WanderingFoodCart",
        github:"https://github.com/hermiaTT/WanderingFoodCart"
    },
    {
        id:4,
        level:"04",
        name:"Green Food",
        shortName:"GF",
        status:"BUILT",
        role:"APPLICATION",
        accent:"#C9A6FF",
        description:"An open-source application for users to calculate daily CO2 emissions.",
        tags:["Java"],

        demo:"https://github.com/hermiaTT/Green-Food-APP",
        github:"https://github.com/hermiaTT/Green-Food-APP"
    },
    {
        id:5,
        level:"05",
        name:"Construction Company Website",
        shortName:"WEB",
        status:"LIVE",
        role:"FRONTEND",
        accent:"#FF3E8E",
        description:"A website for a construction company built. Features a responsive design and interactive elements to showcase the company's services and projects.",
        tags:["HTML","CSS","React"],

        demo:"https://www.broskipropertyworks.com.au/",
        github:"https://github.com/hermiaTT/wanShengWebsite"
    },
]
